import React from 'react';
import { useTranslation } from 'react-i18next';

import { usePromptInsert } from './PromptInsertContext.tsx';
import {
    PromptMenuItem,
    PromptPalette,
    PromptTool,
    PromptVariable,
    toolPaletteItems,
    variablePaletteItems,
} from './VoiceAgentPromptEditor.tsx';

// The one palette of the Prompt tab: floats next to the fields and inserts into the editor focused last, so the
// variables and tools are listed once instead of under every text.
const VoiceAgentPromptSidePalette = ({ variables, tools }: { variables: PromptVariable[]; tools: PromptTool[] }) => {
    const { t } = useTranslation('voice_agents');
    const promptInsert = usePromptInsert();
    const insert = (item: PromptMenuItem) => promptInsert?.insert(item);
    return (
        <div className="flex flex-col gap-3">
            <span className="text-xs text-content-weak">
                {promptInsert?.hasTarget ? t('form.prompt.palette.hint') : t('form.prompt.palette.noTarget')}
            </span>
            <PromptPalette
                title={t('promptEditor.variablesTitle')}
                hint={t('promptEditor.variablesHint')}
                items={variablePaletteItems(variables)}
                onInsert={insert}
            />
            <PromptPalette
                title={t('promptEditor.toolsTitle')}
                hint={t('promptEditor.toolsHint')}
                items={toolPaletteItems(tools)}
                onInsert={insert}
                emptyText={t('promptEditor.noTools')}
            />
        </div>
    );
};

export default VoiceAgentPromptSidePalette;
